import fetch from "../config/api";
import request from "../lib/request";
import store from "../store/store";
/**
 * 搜索接口
 */

export const common_service = () =>
    fetch("/common_service", {
        p: "w",
        language: localStorage.language
    });

export const search = (keyword = "1") =>
    fetch("/search", {
        p: "w",
        language: localStorage.language,
        keyword
    });

/**
 * 获取首页文博快讯、相关公告
 */
export const News = (type = "1") =>
    fetch("/news/index", {
        p: "w",
        language: localStorage.language,
        type
    });
/**
 * 获取首页文博资讯和相关公告详情
 */
export const NewsDetail = news_id =>
    fetch("/news/news_detail", {
        p: "w",
        language: localStorage.language,
        news_id
    });

/**
 * 文博资讯和相关公告, 大事件， 改扩建工程列表
 */
export const NewsList = (type = "1", pageNum = "1", take = "10") =>
    fetch("/news/news_list", {
        p: "w",
        language: localStorage.language,
        type,
        skip: (pageNum - 1) * take, // 从第几个开始
        take // 取几条数据
    });
/**
 * 详情内容
 */
export const museumBrief = (type = 1) =>
    fetch("/museum_brief/detail", {
        p: "w",
        language: localStorage.language,
        type // 1 表示开闭馆时间 2表示交通路线 3表示历史沿革 4表示藏馆简介 5表示馆长致辞 6表示馆长信箱 7票务预约简介 8 文物征集 9 联合工作站简介
    });

/**
 * 首页展览(专题展览和特展回眸每项最多返回3条)
 */
export const Exhibition = () =>
    fetch("/exhibition/index", {
        p: "w",
        language: localStorage.language
    });

/**
 * 展览列表
 */
export const ExhibitionList = (type = "1", pageNum = "1", take = "10") =>
    fetch("/exhibition/list", {
        p: "w",
        language: localStorage.language,
        type,
        skip: (pageNum - 1) * take, // 从第几个开始
        take // 取几条数据
    });

/**
 * 展览详情
 */
export const ExhibitionDetail = (exhibition_id = "") =>
    fetch("/exhibition/detail", {
        p: "w",
        language: localStorage.language,
        exhibition_id
    });

/**
 * 首页珍品赏析接口(最多返回4条)
 */
export const ExhibitionSpecial = () =>
    fetch("/exhibit/index", {
        p: "w",
        language: localStorage.language
    });

/**
 * 展品详情页-地图导览
 * /api/exhibit/guide
 */
export const ExhibitionGuide = exhibit_id =>
    request({
        url: "/exhibit/guide",
        method: "get",
        params: {
            p: "w",
            language: localStorage.language,
            exhibit_id
        },
        hasNoBear: true
    });

/**
 * 珍品赏析, 文物快览列表
 */
export const ExhibitionSpecialList = (pageNum = "1", take = "10", classVal) =>
    fetch("/exhibit/exhibit_list", {
        p: "w",
        language: localStorage.language,
        skip: (pageNum - 1) * take, // 从第几个开始
        take, // 取几条数据
        class: classVal
    });

/**
 * 珍品文物列表
 */
export const zhenpinList = () =>
    fetch("/exhibit/zhenpin_list", {
        p: "w",
        language: localStorage.language
    });

/**
 * 文物详情
 */
// export const exhibitDetail = (exhibit_id = '') => fetch('/exhibit/exhibit_detail', {
//     p: 'w',
//     language: localStorage.language,
//     exhibit_id
// })
export function exhibitDetail(exhibit_id = "") {
    return request({
        url: "/exhibit/exhibit_detail",
        method: "get",
        params: {
            p: "w",
            language: localStorage.language,
            exhibit_id: exhibit_id
        },
        hasNoBear: true
    });
}

/**
 * 全景漫游
 */
export const allScene = () =>
    fetch("/exhibit/all_scene", {
        p: "w",
        language: localStorage.language
    });
export const allSceneList = () =>
    fetch("/exhibit/all_scene_list", {
        p: "w",
        language: localStorage.language
    });

/**
 * 问卷调查列表
 */
export const questionList = () =>
    fetch("/question/question_list", {
        p: "w",
        language: localStorage.language
    });

/**
 * 问卷调查题库
 */
export const getQuestionList = (question_id = "") =>
    fetch("/question/get_question", {
        p: "w",
        language: localStorage.language,
        question_id
    });

/**
 * 问卷调查答题提交
 */
export const submitQuestionAnswer = (data = "", num = "1", ques_id = "1") =>
    fetch(
        "/question/postquesinfo_new",
        {
            p: "w",
            language: localStorage.language,
            data,
            num,
            ques_id
        },
        "POST"
    );

/**
 * 学术列表
 */
export const studyList = (type = "1", pageNum = "1", take = "10") =>
    fetch("/study/list", {
        p: "w",
        language: localStorage.language,
        type,
        skip: (pageNum - 1) * take, // 从第几个开始
        take // 取几条数据
    });

/**
 * 增加下载次数
 */
export const addDownloadCount = (study_id = 0) =>
    fetch(
        "/study/incr_download_count",
        {
            p: "w",
            language: localStorage.language,
            study_id
        },
        "POST"
    );

/**
 * 学术详情
 */
export const studyDetail = (study_id = "") =>
    fetch("/study/detail", {
        p: "w",
        language: localStorage.language,
        study_id
    });

/**
 * 教育活动主页接口
 */
export const activityIndex = () =>
    fetch("/activity/index", {
        p: "w",
        language: localStorage.language
    });

/**
 * 活动列表
 */
export const activityList = (type = "1", pageNum = "1", take = "10") =>
    fetch("/activity/activity_list", {
        p: "w",
        language: localStorage.language,
        type,
        skip: (pageNum - 1) * take, // 从第几个开始
        take // 取几条数据
    });

/**
 * 志愿者模块首页
 */
export const volunteerIndex = () =>
    fetch("/volunteer/index", {
        p: "w",
        language: localStorage.language
    });

/**
 * 志愿者风采列表
 */
export const volunteerMien = (pageNum = "1", take = "10") =>
    fetch("/volunteer/list", {
        p: "w",
        language: localStorage.language,
        skip: (pageNum - 1) * take, // 从第几个开始
        take // 取几条数据
    });

/**
 * 志愿者风采详情
 */
export const volunteerMienDetail = (volunteer_id = "") =>
    fetch("/volunteer/detail", {
        p: "w",
        language: localStorage.language,
        volunteer_id
    });

/**
 * 教育活动详情
 */
export const huodongDetail = (activity_id = "") =>
    fetch("/activity/activity_detail", {
        p: "w",
        language: localStorage.language,
        activity_id
    });

/**
 * 闭馆日期列表
 */
export const closeDate = () =>
    fetch("/ticket/close_date", {
        p: "w"
    });

/**
 * 提交预约
 */
export const submitApply = () =>
    fetch(
        "/ticket/submit_yuyue",
        {
            p: "w",
            phone: JSON.parse(localStorage.subApplyDataObj).phone,
            date: JSON.parse(localStorage.subApplyDataObj).date,
            list: JSON.parse(localStorage.subApplyDataObj).list
        },
        "POST"
    );

/**
 *  科普知识列表
 */
export const knowledgeList = (type = "1", pageNum = "1", take = "10") =>
    fetch("/knowledge/index", {
        p: "w",
        language: localStorage.language,
        type,
        skip: (pageNum - 1) * take, // 从第几个开始
        take // 取几条数据
    });

/**
 *  文物修复保护的列表
 */
export const exhibitRepair = (pageNum = "1", take = "10") =>
    fetch("/volunteer/exhibit_repair", {
        p: "w",
        language: localStorage.language,
        skip: (pageNum - 1) * take, // 从第几个开始
        take // 取几条数据
    });

/**
 *  知识详情
 */
export const knowledgeDetail = (knowledge_id = "") =>
    fetch("/knowledge/detail", {
        p: "w",
        language: localStorage.language,
        knowledge_id
    });

/**
 *  文创列表接口
 */
export const wenchuangList = (type = "1", pageNum = "1", take = "10") =>
    fetch("/wenchuang/list", {
        p: "w",
        language: localStorage.language,
        type,
        skip: (pageNum - 1) * take, // 从第几个开始
        take // 取几条数据
    });

/**
 *  文创动态首页
 */
export const wenchuangIndex = () =>
    fetch("/wenchuang/wenchuang_index", {
        p: "w",
        language: localStorage.language
    });

/**
 *  文创动态列表
 */
export const wcdynamicList = (pageNum = "1", take = "10") =>
    fetch("/wenchuang/wenchuang_news_list", {
        p: "w",
        language: localStorage.language,
        skip: (pageNum - 1) * take, // 从第几个开始
        take // 取几条数据
    });

/**
 *  文创动态详情
 */
export const wcdynamicDetail = (wenchuang_news_id = "") =>
    fetch("/wenchuang/wenchuang_news_detail", {
        p: "w",
        language: localStorage.language,
        wenchuang_news_id
    });

/**
 *  意见反馈
 */
export const feedback = (
    user_name = "",
    phone = "",
    user_mail = "",
    content = ""
) =>
    fetch(
        "/feedback/feedback_save",
        {
            p: "w",
            language: localStorage.language,
            captcha: "",
            user_name,
            user_mail,
            content,
            phone
        },
        "POST"
    );

/**
 * 获取意见反馈的列表
 * /api/feedback/feedback_list
 * @returns
 */
export const feedbackListApi = params =>
    request({
        url: "/feedback/feedback_list",
        method: "get",
        params: {
            p: "w",
            language: localStorage.language,
            ...params
        },
        hasNoBear: true
    });
/**
 *  访问次数
 */
export const incrwebsit = () =>
    fetch("/incr_websit", {
        p: "w"
    });
export const banner_for_index = () =>
    fetch("/banner_for_index", {
        p: "w"
    });
export const time_desc = () =>
    fetch("/time_desc", {
        p: "w"
    });
export const activityForIndex = () =>
    fetch("/activity/activityForIndex", {
        p: "w",
        language: localStorage.language
    });

// 个人中心相关接口
// 用户详情
export function getUserInfoApi() {
    return request({
        url: store.state.ssoApiBase + "/getUserInfo",
        method: "post",
        data: {}
    });
}
// 绑定用户邮箱
export function bindUserEmailApi(email) {
    return request({
        url: store.state.ssoApiBase + "/bindUserEmail",
        method: "post",
        data: {
            email
        }
    });
}
// 游客修改密码: /changeCustomerPassword
// 更改游客昵称: /changeNickName
/**
 * 更换昵称
 * /changeNickName
 * @returns
 */
export function changeNickNameApi(nickName) {
    return request({
        url: store.state.ssoApiBase + "/changeNickName",
        method: "post",
        data: {
            nickName
        }
    });
}
/**
 * changeCustomerPassword
 * 更改密码
 */
export function changeCustomerPasswordApi(params) {
    return request({
        url: store.state.ssoApiBase + "/changeCustomerPassword",
        method: "post",
        data: {
            ...params
        }
    });
}

// 解绑用户邮箱
export function unBindUserEmailApi() {
    return request({
        url: store.state.ssoApiBase + "/unBindUserEmail",
        method: "GET"
    });
}
export const getDomainInfoApi = () =>
    fetch("/get_url", {
        p: "w"
    });

// 藏品征集，获取藏品年代和藏品类型 /api/get_type_year
const CP_URL = process.env.VUE_APP_CP_URL;
export const getTypeYear = () =>
    fetch(CP_URL + "/api/get_type_year", {
        p: "w"
    });
// 藏品提交
export const submitZJWeb = data =>
    fetch(
        CP_URL + "/api/submit_zjweb",
        {
            p: "w",
            ...data
        },
        "post"
    );

// 收藏藏品
// /api/collection
export function setCollect(rela_id) {
    return request({
        url: "/collection",
        method: "GET",
        params: {
            p: "w",
            rela_id: rela_id
        },
        hasNoBear: true
    });
}
// 收藏列表
// /api/collection_list
export function getCollectList({ page, limit }) {
    return request({
        url: "/collection_list",
        method: "GET",
        params: {
            p: "w",
            page: page,
            limit: limit
        },
        hasNoBear: true
    });
}

// 判断是否开启会员注册
const memberBaseUrl = process.env.VUE_APP_MEMBER_BASE_URL;
export const getMemberIsOpen = () =>
    fetch(
        memberBaseUrl + "/api/member/is_open",
        {
            p: "w"
        },
        "get"
    );

/**
 * 获取图形验证码
 */
export function getCodeImg() {
    return request({
        url: store.state.ssoApiBase + "/api/captchaImage",
        method: "get"
    });
}

/**
 * 校验验证码
 * /prod-api/api/checkVerifyCode
 */
export function checkVerifyCodeApi(params) {
    return request({
        url: store.state.ssoApiBase + "/api/checkVerifyCode",
        method: "post",
        data: {
            ...params
        }
    });
}



// WEBPACK FOOTER //
// ./src/ports/getData.js